import React, { useEffect, useRef, useState } from "react";
import { SrAgentChatMessage } from "./sr-agent-chat-message";
import { SrAgentChatInput } from "./sr-agent-chat-input";
import { SrChatSuggestions } from "./sr-chat-suggestions";
import { SrChatTyping } from "./sr-chat-typing";
import { SrChatListPanel } from "./sr-chat-list-panel";
import { SrChatHeader } from "./sr-chat-header";
import { useSrAgentChat } from "./useSrAgentChat";
import "./sr-chat.css";

export const SrAgentChatPanel: React.FC = () => {
    const {
        messages,
        sending,
        conversationId,
        sendMessage,
        sendVoice,
        clearChat,
        loadChat,
    } = useSrAgentChat();
    const bottomRef = useRef<HTMLDivElement>(null);
    const [showChats, setShowChats] = useState(false);
    const showHints = !showChats && messages.length <= 1 && !sending;

    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages, sending, showChats]);

    const openChat = async (id: string) => {
        await loadChat(id);
        setShowChats(false);
    };

    return (
        <div className="sr-agent-chat flex h-full min-h-0 flex-col bg-gradient-to-b from-slate-100/80 via-slate-50 to-white">
            <SrChatHeader
                showChats={showChats}
                sending={sending}
                onToggleChats={() => setShowChats((v) => !v)}
                onNewChat={() => {
                    clearChat();
                    setShowChats(false);
                }}
            />
            <div className="flex-1 space-y-4 overflow-y-auto px-4 py-5">
                {showChats ? (
                    <SrChatListPanel
                        activeId={conversationId}
                        onOpen={openChat}
                    />
                ) : (
                    <>
                        {messages.map((m) => (
                            <SrAgentChatMessage
                                key={m.id}
                                message={m}
                                disabled={sending}
                                onPickName={sendMessage}
                            />
                        ))}
                        {sending && <SrChatTyping />}
                    </>
                )}
                <div ref={bottomRef} />
            </div>
            {!showChats && (
                <div className="space-y-2.5 border-t border-slate-200/80 bg-white/95 px-3 pb-3 pt-2.5 shadow-[0_-6px_20px_rgba(15,23,42,0.04)]">
                    {showHints && (
                        <SrChatSuggestions
                            disabled={sending}
                            onPick={sendMessage}
                        />
                    )}
                    <SrAgentChatInput
                        disabled={sending}
                        onSend={sendMessage}
                        onSendVoice={sendVoice}
                    />
                </div>
            )}
        </div>
    );
};
